// extracted by mini-css-extract-plugin
module.exports = {"container":"i_JW","icon":"i_JX","icon-sizes-xs":"i_JY","text":"i_JZ","label":"i_Ja"};